export enum MediaCategory {
  VIDEO = 'Video',
  PREVIEW = 'Preview',
}
